import { z } from 'zod';

import { StrictAddress } from '../Address';
import { PropertyId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const DeletePropertyAddressEvent = BaseLoanEvent.extend({
  type: z.literal('deletePropertyAddress'),
  propertyId: PropertyId,
  addressToDelete: StrictAddress,
});
export type DeletePropertyAddressEvent = z.infer<typeof DeletePropertyAddressEvent>;
